import script from "./SidebarContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./SidebarContent.vue?vue&type=script&lang=ts&setup=true"

import "./SidebarContent.vue?vue&type=style&index=0&id=325aac9b&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-325aac9b"]])

export default __exports__